/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import axios from '@/axios.js';

export default {
  SET_ORGANIZATION(state, value) {
    state.orgData = value;
  },
  // SET_ALEX_INVITEES(state, value) {
  //   state.alexUsers.unshift(value);
  // },
  // SET_USERS_IN_ALEX(state, value) {
  //   state.alexUsers = value;
  // },
  SET_ORGANIZATION_SLUG(state, value) {
    state.organizationSlug = value;
  },
  SET_ORGANIZATION_SUBADMIN(state, value) {
    if(state.orgData['subAdmins']) state.orgData['subAdmins'].push(value);
    else {
      state.orgData['subAdmins'] = [];
      state.orgData['subAdmins'].push(value);
    }
  },
  SET_MY_ORGANIZATIONS(state, value) {
    state.myOrganizations = value;
  },
  REMOVE_ORGANIZATION_SUBADMIN(state, orgSubAdminId) {
    const index = state.orgData['subAdmins'].findIndex(sa => { return sa._id === orgSubAdminId });
    state.orgData['subAdmins'].splice(index, 1);
  },
  // SET_BOARD_CREATION_DETAILS(state, value) {
  //   state.boardCreation = value;
  // },
  // SET_ALL_BOARDS(state, value) {
  //   state.allBoards = value;
  // },
  // SET_CURRENT_BOARD(state, value) {
  //   state.currentBoard = value;
  // },
  // SET_CURRENT_BOARD_USERS(state, value) {
  //   state.currentBoardUsers = value;
  // }
  SET_CUSTOM_ROUTE_TITLE(state, value) {
    state.customRouteTitle = value;
  },
  SAVE_COACH_CONFIGS(state, value) {
    if(!state.orgData['appConfigs']) state.orgData['appConfigs'] = {};
    if(!state.orgData['appConfigs']['coach']) state.orgData['appConfigs']['coach'] = {};
    state.orgData['appConfigs']['coach'] = value;
    state.orgData = { ...state.orgData };
  },
  SAVE_HIBOB_CONFIGS(state, value) {
    if(!state.orgData['appConfigs']) state.orgData['appConfigs'] = {};
    if(!state.orgData['appConfigs']['hibob']) state.orgData['appConfigs']['hibob'] = {};
    state.orgData['appConfigs']['hibob'] = value;
    state.orgData = { ...state.orgData };
  },
  SAVE_EMPLOYEES(state, value) {
    state.employees = value;
  },
  ADD_EMPLOYEE(state, newEmployee) {
    state.employees.push(newEmployee);
  },
  SAVE_ORGANIZATION_CONFIGURATION(state, value) {
    state.organizationConfiguration = value;
  },
  SET_ACTIVE_RESUME_BATCH_ID(state, batchId) {
    state.activeResumeBatchId = batchId;
  },
  
  SET_BATCH_PROGRESS(state, progress) {
    state.activeBatchProgress = progress;
  },
  SET_ACTIVE_BATCH_PROGRESS(state, progress) {
    state.activeBatchProgress = progress;
  },
  SET_RESUME_BATCH_STATUS(state, status) {
    state.resumeBatchStatus = status;
  },
  CLEAR_RESUME_BATCH(state) {
    state.activeResumeBatchId = null;
    state.resumeBatchStatus = null;
    state.resumeBatchStartTime = null; // Clear the start time
  },
  UPDATE_BATCH_PROGRESS(state, percentage) {
    state.activeBatchProgress = percentage;
},
}